import React from 'react'
import '../Assets/Styles/Layout/Footer.scss'

export const Footer = () => {
  return (
    <div className='footer'>@copyright Footer</div>
  )
}
